import React from 'react';
import { useTranslation } from 'react-utilities';
import makeTranslateWithLink from '../../utils/makeTranslateWithLink';
import { NAPageItemConfigType } from '../ConfigTypes';
import getRobloxUrl from '../../utils/getRobloxUrl';
import { EventTypes } from '../../services/eventConstants';

const termsOfUseUrl = getRobloxUrl('/info/terms');

/**
 * Message and link regarding Roblox's terms of use. Always shown
 */
const TermsOfUsePageItem = (): JSX.Element => {
  const { translate } = useTranslation();
  const translateWithLink = makeTranslateWithLink(translate);

  return (
    <div data-testid='terms-of-use'>
      {translateWithLink(
        'Description.Violation',
        termsOfUseUrl,
        undefined,
        EventTypes.TermsOfUseClicked
      )}
    </div>
  );
};

const TermsOfUsePageItemConfig: NAPageItemConfigType = {
  getIsVisible: () => {
    return true;
  },
  renderComponent: TermsOfUsePageItem,
  configName: 'terms-of-use'
};

export default TermsOfUsePageItemConfig;
